import {
  Navigate,
  Route,
  BrowserRouter,
  Routes,
} from "react-router-dom";
import { AdminLayout } from "../components/layout/AdminLayout";
import { RequireAuth } from "../lib/auth/RequireAuth";
import { RequireAdminRole } from "../lib/auth/RequireAdminRole";
import { useAuth } from "../lib/auth/AuthProvider";
import { LoginPage } from "../pages/Login";
import { DashboardPage } from "../pages/Dashboard";
import { EmployeesListPage } from "../pages/EmployeesList";
import { EmployeeDetailPage } from "../pages/EmployeeDetail";
import { HealthOverviewPage } from "../pages/HealthOverview";
import { AlertsPage } from "../pages/Alerts";
import { SettingsPage } from "../pages/Settings";

// Role-aware landing: admin → dashboard (measurement KPIs); site_admin can't see
// the dashboard (ADR-027 403), so they land on the employees list instead.
function HomeRedirect() {
  const { user } = useAuth();
  return (
    <Navigate to={user?.role === "admin" ? "/dashboard" : "/employees"} replace />
  );
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<HomeRedirect />} />
          {/* Measurement-bearing pages: HQ-admin only (ADR-027). site_admin is
              redirected to /employees by RequireAdminRole. */}
          <Route
            path="/dashboard"
            element={
              <RequireAdminRole>
                <DashboardPage />
              </RequireAdminRole>
            }
          />
          <Route
            path="/overview"
            element={
              <RequireAdminRole>
                <HealthOverviewPage />
              </RequireAdminRole>
            }
          />
          <Route path="/employees" element={<EmployeesListPage />} />
          <Route path="/employees/:id" element={<EmployeeDetailPage />} />
          <Route
            path="/alerts"
            element={
              <RequireAdminRole>
                <AlertsPage />
              </RequireAdminRole>
            }
          />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
